import React, { useEffect, useState } from "react";
import { notiError } from "../../utils/notiUltils";
import { Card, CardContent, CardHeader, Grid2 } from "@mui/material";
import StandardDataItem from "./StandardDataItem";
import { blue, deepPurple, green, orange } from "@mui/material/colors";
import {
  AccessibilityNew,
  CrisisAlert,
  DirectionsCarFilled,
  ShutterSpeed,
} from "@mui/icons-material";
import { formatNumber } from "../modules";

function StandardData({ api }) {
  const [dataSource, setDataSource] = useState({});
  useEffect(() => {
    api
      .get("/dashboard2", localStorage.getItem("token"))
      .then((data) => {
        setDataSource(data);
      })
      .catch((error) => {
        console.error(error);
        notiError({ message: error, position: "center" });
      });
  }, [api]);

  return (
    <Card
      //elevation={8}
      //variant="outlined"
      sx={{ p: 1, height: "100%", display: "flex", flexDirection: "column" }}
    >
      <CardHeader
        title={"รายการข้อมูลมาตรฐาน"}
        titleTypographyProps={{ variant: "subtitle1", whiteSpace: "nowrap" }}
        subheader={`ทั้งหมด ${dataSource.percent}% การเจริญเติบโต 😎 เดือนนี้`}
        subheaderTypographyProps={{ variant: "caption", whiteSpace: "nowrap" }}
      />
      <CardContent
        sx={{
          pt: 0,
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "end",
        }}
      >
        <Grid2 container spacing={2}>
          <Grid2 size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 3 }}>
            <StandardDataItem
              icon={<AccessibilityNew />}
              iconColor={deepPurple["A200"]}
              title={"เขตชุมชน"}
              text={formatNumber(dataSource.community)}
            />
          </Grid2>
          <Grid2 size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 3 }}>
            <StandardDataItem
              icon={<ShutterSpeed />}
              iconColor={green[500]}
              title={"จำกัดความเร็ว"}
              text={dataSource.speedLimit}
            />
          </Grid2>
          <Grid2 size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 3 }}>
            <StandardDataItem
              icon={<CrisisAlert />}
              iconColor={orange[500]}
              title={"พื้นที่เสี่ยง"}
              text={formatNumber(dataSource.dangerous)}
            />
          </Grid2>
          <Grid2 size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 3 }}>
            <StandardDataItem
              icon={<DirectionsCarFilled />}
              iconColor={blue[500]}
              title={"ยานพาหนะ"}
              text={formatNumber(dataSource.vehicle)}
            />
          </Grid2>
        </Grid2>
      </CardContent>
    </Card>
  );
}

export default StandardData;
